<template>
    <div class="child-account-container">
        <el-card class="mb16 custom-card-class">
            <div class="child-account-query">
                <div class="child-account-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 用户名:</span>
                        <el-input class="query-input" size="small" placeholder="请输入" v-model="query.user" clearable></el-input>                
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 账户状态:</span>
                        <el-select v-model="query.status" placeholder="请选择" size="mini" class="mr20">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="未启用" value="0"></el-option>
                        </el-select>
                    </div>  
                </div>
                <div class="child-account-query-btn">
                    <el-button class="query-btn" type="primary" size="small" :disabled="query.loading" @click="getData" icon="el-icon-search">查询</el-button>
                    <el-button class="query-btn cancel" plain size="small" :disabled="query.loading" @click="reset" icon="el-icon-refresh">重置</el-button>
                </div>
            </div>
        </el-card>
        <!-- <div class="child-account-btn-div">            
            <el-button class="add-btn" type="primary" size="small" @click="addChildAccount">新增账户</el-button>
        </div> -->
        <el-card>
            <div class="child-account-table-div">
                <el-table class="table-class" :data="table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <el-table-column prop="id" label="账户ID" width="120px"></el-table-column>
                    <el-table-column prop="username" label="用户名"  width="160px"></el-table-column>
                    <el-table-column label="状态" width="120px">
                        <template slot-scope="scope">
                            <el-tag type="success" size="mini" v-if='scope.row.status == 1'>已启用</el-tag>
                            <el-tag type="danger" size="mini" v-if='scope.row.status == 0'>未启用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.create_time}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180px">
                        <template slot-scope="scope">
                            <div class="textCenter">
                                <el-button class="table-operation" type="text" @click="editChildAccount(scope.row)" icon="el-icon-edit-outline">编辑</el-button>
                                <el-button class="cdanger delete-btn"  type="text" @click="deleteChildAccount(scope.row)" :disabled="dialog.loading" icon="el-icon-delete">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="query.loading" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                        :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
                </div>
            </div>
        </el-card>
        <div class="dialog-div">
            <!-- <el-dialog custom-class="new-dialog-class" :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" @close="close" width="500px" :close-on-click-modal="false">
                <el-form :model="dialog.form" :rules="rules" ref="form" size="mini" label-width="100px">
                    <el-form-item label="用户名:" prop="user">
                        <el-input v-model="dialog.form.user" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                    </el-form-item>     
                    <el-form-item label="启用状态:" prop="">
                        <el-switch v-model="dialog.form.status" active-color="#13ce66" ></el-switch>
                    </el-form-item>      
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button class="dialog-btn" size="mini" @click="close" :disabled="dialog.loading">取 消</el-button>
                    <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="dialog.loading">确 定</el-button>
                </div>
            </el-dialog> -->
            <el-dialog custom-class="edit-dialog-class" :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visibleEdit" @close="closeEdit" width="500px" :close-on-click-modal="false">
                <el-form :model="dialog.formEdit" :rules="rules" ref="formEdit" size="mini" label-width="100px">
                    <el-form-item label="用户名:" prop="user">
                        <el-input v-model="dialog.formEdit.user" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                    </el-form-item>     
                    <el-form-item label="启用状态:" prop="">
                        <el-switch v-model="dialog.formEdit.status"></el-switch>
                    </el-form-item>      
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button class="dialog-btn" size="mini" @click="closeEdit" :disabled="dialog.loading">取 消</el-button>
                    <el-button class="dialog-btn" type="primary" size="mini" @click="sureEdit" :disabled="dialog.loading">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {
		Message
	} from 'element-ui'
export default {
    data(){
        const validateName = function(rule, val, callback) {
                if(val){
                    if(val.length < 2 || val.length > 10){
                        return callback(new Error("名称长度不得少于 2 个字符，最多 10 个字符"));
                    }
                    if (/^\d+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else {
                        callback();
                    }
                }
            };
        return{
            query:{
                user:'',
                status:'',
                page:1,
                pageSizesArr:[10,50,200,500],
                total:0,
                pageSize: 10,
                loading:false,
            },
            table:{
                tableData:[],
                height:'200px',
            },
            dialog:{
                    //新增 编辑弹窗
                top:"15vh",
                visible:false,
                title:'新增账户',
                type:'new',
                loading:false,
                form:{
                    id:'',
                    user:'',
                    status:true
                },
                formEdit:{
                    id:'',
                    user:'',
                    status:true
                },
                
                
            }, 
            rules:{
                user:[
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    {validator:validateName, trigger: 'blur'}
                ],
                
            },
        }
    },
    created() {
       this.getUsers()
    },
    methods:{
         //计算表格高度
         getTableHeight(){
            this.$nextTick(() => {
                let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                let queryBox = document.getElementsByClassName('child-account-query')[0].offsetHeight;
                // let queryBtn = document.getElementsByClassName('child-account-btn-div')[0].offsetHeight;
                let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
                let documentHeight = document.documentElement.clientHeight
                this.table.height = documentHeight - topNav - 20 - queryBox - 26 - 30 - pageBox - 70 +'px'
            })  
        },
        ////计算窗口位置
        getDialogTop(className){
            this.$nextTick(() => {			
                let documentHeight = document.documentElement.clientHeight
                let dialogdiv =  document.getElementsByClassName(className)[0].offsetHeight
                this.dialog.top =( documentHeight - dialogdiv) / 2 +'px'
                console.log(documentHeight,'===',dialogdiv,'===',this.dialog.top)
            })
        },
        //查询按钮
        getData(){
            this.query.page = 1;
            this.query.total = 0;
            this.getUsers()
        },
        //重置查询条件
        reset(){
            this.query.page = 1;
            this.query.total = 0;
            this.query.user = '';
            this.query.status = ''
            this.getUsers()
        },
        // 分页查询数据
        handleSizeChange(val){
            this.query.pageSize = val;
                this.query.page = 1
                this.query.total = 0
                this.getUsers()
        },
        handleCurrentChange(val){
            this.query.page = val
                this.getUsers()
        },
        //列表查询接口
        getUsers(){
            this.getTableHeight()
            let data = {
                "user": this.query.user,//  子账号
                "status": this.query.status, // 状态 0 停用   1  启用
                "size": this.query.pageSize,
                "page": this.query.page,
            }
            this.query.loading = true;
            this.$api.getUsers(data).then(res=>{
                this.query.loading = false;
                if(res.status == 1){
                    this.table.tableData = res.data.data
                    this.query.total = res.data.total;
                }else{
                    Message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    });
                }
            }).catch(e=>{
                this.query.loading = false;
            })
        },
        //新增账户
        addChildAccount(){
            this.dialog.visible = true
            this.dialog.title = '新增账户'
            this.dialog.type='new'
            this.getDialogTop('new-dialog-class')
        },
        //编辑账户
        editChildAccount(item){
            this.dialog.visibleEdit = true
            this.dialog.title = '编辑账户'
            this.dialog.type='edit'
            this.getDialogTop('edit-dialog-class')
            this.dialog.formEdit.id = item.id;
            this.dialog.formEdit.user = item.username;
            this.dialog.formEdit.status = item.status == 0 ? false : true;
        },
        //关闭弹窗
        close(){
            this.dialog.visible = false
            this.dialog.title = ''
            this.dialog.type=''
            this.dialog.form.id = '';
            this.dialog.form.user = '';
            this.dialog.form.status = true;
            this.resetForm('form')
        },
        //关闭编辑弹窗
        closeEdit(){
            this.dialog.visibleEdit = false
            this.dialog.title = ''
            this.dialog.type=''
            this.dialog.formEdit.id = '';
            this.dialog.formEdit.user = '';
            this.dialog.formEdit.status = true;
            this.resetForm('formEdit')
        },
         //重置表单
         resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //确认新增 或 编辑账户
        sure(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.addUser()
                   
                } else {
                    return false;
                }
            }); 
        },
        sureEdit(){
            this.$refs['formEdit'].validate((valid) => {
                if (valid) {
                    this.setUser()
                       
                } else {
                    return false;
                }
            }); 
        },
        //新增接口
        addUser(){
            let data = {
                "user": this.dialog.form.user,//  子账号
                "status": this.dialog.form.status?1:0 // 状态 0 停用   1  启用
            }
            this.dialog.loading = true;
            this.$api.addUser(data).then(res => {
                this.dialog.loading = false;
                if(res.status == 1){
                    this.dialog.visible = false
                    this.getData();
                    Message({
                        message: res.msg,
                        type: 'success',
                        duration: 3 * 1000
                    })
                }else{
                    Message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.dialog.loading = false;
            })
        },
        //编辑子账号接口
        setUser(){
            let data = {
                "id":this.dialog.formEdit.id,
                "user": this.dialog.formEdit.user,//  子账号
                "status": this.dialog.formEdit.status?1:0 // 状态 0 停用   1  启用
            }
            this.dialog.loading = true;
            this.$api.setUser(data).then(res=>{
                this.dialog.loading = false;
                if(res.status == 1){                    
                    this.dialog.visibleEdit = false
                    this.getUsers();
                    Message({
                        message: res.msg,
                        type: 'success',
                        duration: 3 * 1000
                    })
                }else{
                    Message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.dialog.loading = false;
            })
        },
        //删除账户
        deleteChildAccount(item){
            this.dialog.form.id = item.id;
            this.$confirm( '确定要删除这个子账户吗', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                .then(() => {
                  this.delUser()
                })
                .catch(action => {
                   
                });
        },
        //删除账户接口
        delUser(){
            let data ={
                id:this.dialog.form.id,
            }
            this.dialog.loading = true;
            this.$api.delUser(data).then(res=>{
                this.dialog.loading = false;
                if(res.status == 1){
                    this.getData()
                    Message({
                        message:res.msg,
                        type: 'success',
                        duration: 3 * 1000
                    })
                }else{
                    Message({
                        message:res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{                
                this.dialog.loading = false;
            })
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
    .child-account-container{
        .custom-card-class{
            .el-card__body{
                padding-top:14px;
                padding-bottom:14px;
            }
        }
        // .dialog-div{
        //     .el-form-item__label{
        //         width: 100px !important;
        //     }
        // }
        .el-switch__core{
            width: 40px !important;
        }
    }
	// @import '@/style/variables.scss';
</style>
<style scoped lang="scss">
.child-account-container{
    padding-top: 10px;
    padding-right: 10px;
    .child-account-query{
        padding-left:10px;
        padding-right: 10px;
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items:center;
        .child-account-query-input{
            display:flex;
            flex-wrap: wrap;
            .query-input-item{
                margin-right:25px;
                display:flex;
                font-size:14px;
                align-items:center;
                margin-bottom: 8px;
                margin-top:8px;
                .input-item-label{
                    white-space: nowrap;
                    margin-right: 10px;
                }
                .query-input{
                    width: 200px;
                    margin-left: 20px;
                }
                
            }
        }
        .child-account-query-btn{
            display:flex;
            margin-bottom: 8px;
            margin-top:8px;
            margin-left: 7px;
            .query-btn{
                width: 80px;
                height: 30px;
            }
            .cancel{
                margin-left: 14px;
            }
        }
    }
    // .child-account-btn-div{            
    //     padding-left:10px;
    //     .add-btn{
    //         width: 80px;
    //         height: 30px;
    //         margin-top:31px;
    //     }
    // }
    .child-account-table-div{
        // margin-top: 31px;
            margin-left:10px;
            .table-operation{
                margin: 0 24px;
            }
            
           .delete-btn{
            &:hover{
                color:#fab6b6,
            }
            &:focus{
                color:#fab6b6,
            }
           }
           .pageBox{
                padding: 16px 20px;
                border-top: 1px solid #ebeef5;
                background-color: #fafcff;

           }
    }
    .dialog-div{
        .new-dialog-class,.edit-dialog-class{
            .dialog-div-input{
                // width: 200px;
            } 
            .dialog-btn{
                margin-left: 15px;
                width: 80px;
            }
        }
    }
}
</style>
